<template>

    <section class="news bottom-space vertical-padding">
        <div class="ink-grid">

            <h2 class="section-title text-center">Ler e acompanhar</h2>

            <div class="column-group gutters">
                <div class="all-25 medium-50 small-100 tiny-100" v-for="n in 4">
                    <NewsCard></NewsCard>
                </div>
            </div>

            <div class="ink-flex push-center">
                <a class="ink-button" href="/news">Ver mais</a>
            </div>

        </div>

    </section>

</template>

<script>

    import NewsCard from '../shared/news-card.vue'

    export default {

        components: {
            NewsCard
        },


    };
</script>